import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { Button } from './ui/button';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <Button
      onClick={toggleTheme}
      className="theme-toggle-button"
      variant="outline"
      size="icon"
    >
      {theme === 'light' ? (
        <Moon className="theme-icon" size={20} />
      ) : (
        <Sun className="theme-icon" size={20} />
      )}
    </Button>
  );
};

export default ThemeToggle;